import { Lightning } from '@lightningjs/sdk';
import { Theme } from '../../config/theme';
import { ScreenSize } from '../../api/ScreenSize';
import { SelectOptionList } from '../option/SelectOptionList';

export class SelectSettingsPage extends Lightning.Component {
  static _template() {
    return {
      x: 0,
      y: 0,
      w: w => w,
      h: h => h,
      rect: true,
      color: Theme.Colors.Transparent,
      Background: {
        w: w => w,
        h: h => h,
        alpha: 0.75,
        rect: true,
        color: Theme.Colors.Player.Background.Error,
      },
      Options: {
        x: ScreenSize.w * 0.5,
        y: 0,
        mountX: 0.5,
        type: SelectOptionList,
      },
    };
  }

  _init() {
    this.tag('Options').data = { title: this._params.title, options: this._params.options, callback: this._success };
  }

  set params(params) {
    this._params = params;
    this._success = params.onSuccess;
    this._cancelled = params.onCancelled;
  }

  _getFocused() {
    return this.tag('Options');
  }

  _handleBack() {
    this._cancelled && this._cancelled();
  }
}
